const investmentCriteriaDefaults = {
  //purchase
  screenPurchasePrice: false,
  maxPurchasePrice: 500000,
  screenCashNeededPurchase: true,
  maxCashNeededPurchase: 100000,
  cashNeededPurchaseCriteria: {
    derivedFrom: 'purchasePrice',
    unit: '%',
    value: 20,
  },
  screenOnePercentRulePurchase: false,
  screenFiftyPercentRulePurchase: true,
  screenCashFlowPurchase: true,
  minCashFlowPurchase: 150,
  screenCapRatePurchase: false,
  minCapRatePurchase: 5,
  screenTotalRoiYear1Purchase: false,
  minTotalRoiYear1Purchase: 10,

  //buy and hold
  screenSeventyPercentRuleBuyAndHold: true,
  screenTotalProfitBuyAndHold: true,
  totalProfitBuyAndHold: 50000,
  screenCashNeededBuyAndHold: false,
  cashNeededBuyAndHoldCriteria: {
    derivedFrom: 'purchasePrice',
    unit: '%',
    value: 30,
  },
  screenOnePercentRuleBuyAndHold: false,
  screenFiftyPercentRuleBuyAndHold: true,
  screenCashFlowBuyAndHold: true,
  minCashFlowBuyAndHold: 150,
  screenCapRateBuyAndHold: false,
  minCapRateBuyAndHold: 5,
  screenTotalRoiYear1BuyAndHold: false,
  minTotalRoiYear1BuyAndHold: 10,

  // brrrr
  screenSeventyPercentRuleBRRRR: true,
  screenTotalProfitBRRRR: true,
  totalProfitBRRRR: 50000,
  screenCashNeededBRRRR: false,
  screenOnePercentRuleBRRRR: false,
  screenFiftyPercentRuleBRRRR: true,
  screenCashFlowBRRRR: true,
  minCashFlowBRRRR: 150,
  screenCapRateBRRRR: false,
  minCapRateBRRRR: 5,
  screenTotalRoiYear1BRRRR: false,
  minTotalRoiYear1BRRRR: 10,
  cashOutInitialInvestmentBRRRR: true,
  cashOutRehabRefinanceBRRRR: false,
};

export default investmentCriteriaDefaults;
